import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { FileText, ArrowRight, MousePointerClick, DollarSign } from 'lucide-react';
export function FunnelDiagram() {
  const container = {
    hidden: {
      opacity: 0
    },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.3
      }
    }
  };
  const item = {
    hidden: {
      opacity: 0,
      y: 20
    },
    show: {
      opacity: 1,
      y: 0
    }
  };
  return <div className="w-full max-w-3xl mx-auto py-12" data-id="element-2">
      <motion.div variants={container} initial="hidden" animate="show" className="flex items-center justify-between relative" data-id="element-3">
        {/* Step 1: Page */}
        <motion.div variants={item} className="flex flex-col items-center z-10" data-id="element-4">
          <div className="w-20 h-20 rounded-2xl bg-[#1a1a3e] border-2 border-[#2a2a5a] flex items-center justify-center mb-4 shadow-lg shadow-black/20" data-id="element-5">
            <FileText className="text-[#a8c5e0]" size={32} data-id="element-6" />
          </div>
          <span className="text-sm font-bold text-white uppercase tracking-wide" data-id="element-7">
            Page
          </span>
          <span className="text-xs text-[#5a5a7a] mt-1" data-id="element-8">Landing</span>
        </motion.div>

        {/* Connector 1 */}
        <div className="flex-1 h-[2px] bg-[#2a2a5a] mx-4 relative" data-id="element-9">
          <motion.div initial={{
          width: '0%'
        }} animate={{
          width: '100%'
        }} transition={{
          duration: 0.8,
          delay: 0.5
        }} className="absolute top-0 left-0 h-full bg-gradient-to-r from-[#a8c5e0] to-[#ffc978]" data-id="element-10" />
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-[#0f0f2d] px-2" data-id="element-11">
            <ArrowRight size={16} className="text-[#5a5a7a]" data-id="element-12" />
          </div>
        </div>

        {/* Step 2: Action */}
        <motion.div variants={item} className="flex flex-col items-center z-10" data-id="element-13">
          <div className="w-20 h-20 rounded-2xl bg-[#1a1a3e] border-2 border-[#2a2a5a] flex items-center justify-center mb-4 shadow-lg shadow-black/20" data-id="element-14">
            <MousePointerClick className="text-[#ffc978]" size={32} data-id="element-15" />
          </div>
          <span className="text-sm font-bold text-white uppercase tracking-wide" data-id="element-16">
            Action
          </span>
          <span className="text-xs text-[#5a5a7a] mt-1" data-id="element-17">Click/Opt-in</span>
        </motion.div>

        {/* Connector 2 */}
        <div className="flex-1 h-[2px] bg-[#2a2a5a] mx-4 relative" data-id="element-18">
          <motion.div initial={{
          width: '0%'
        }} animate={{
          width: '100%'
        }} transition={{
          duration: 0.8,
          delay: 1.0
        }} className="absolute top-0 left-0 h-full bg-gradient-to-r from-[#ffc978] to-[#7ee0a8]" data-id="element-19" />
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-[#0f0f2d] px-2" data-id="element-20">
            <ArrowRight size={16} className="text-[#5a5a7a]" data-id="element-21" />
          </div>
        </div>

        {/* Step 3: Outcome */}
        <motion.div variants={item} className="flex flex-col items-center z-10" data-id="element-22">
          <div className="w-20 h-20 rounded-2xl bg-[#1a1a3e] border-2 border-[#2a2a5a] flex items-center justify-center mb-4 shadow-lg shadow-black/20" data-id="element-23">
            <DollarSign className="text-[#7ee0a8]" size={32} data-id="element-24" />
          </div>
          <span className="text-sm font-bold text-white uppercase tracking-wide" data-id="element-25">
            Outcome
          </span>
          <span className="text-xs text-[#5a5a7a] mt-1" data-id="element-26">Sale/Lead</span>
        </motion.div>
      </motion.div>
    </div>;
}